import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import Layout from './routes/Layout';
import Home from './components/pages/home';
import Navbar from './components/static/navbar';
import Footer from './components/static/footer';
import ScrollToTop from './hooks/scroll';
import AOSRefresh from './hooks/aos';
import AOS from 'aos';
import "aos/dist/aos.css";
import "leaflet/dist/leaflet.css";
import './App.css';

function App() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true
    });
  }, []);

  return (
    <BrowserRouter>
      <AOSRefresh />
      <ScrollToTop />
      <Navbar />

      <Suspense fallback={<div>Cargando...</div>}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/gmr-enlaces/*" element={<Layout />} />
        </Routes>
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
